import { isAxiosError } from 'axios'
import { AlertCircle } from 'lucide-react'
import { Button } from '../ui/button'

interface ErrorStateProps {
  title?: string
  message: string
  retry?: () => void
  apiError?: unknown
}

export function ErrorState({
  title = 'Não conseguimos mostrar isto agora',
  message,
  retry,
  apiError,
}: ErrorStateProps) {
  const status = isAxiosError(apiError) ? apiError.response?.status : undefined
  const resolvedTitle =
    status === 403 ? 'Acesso negado' : status === 404 ? 'Registro não encontrado' : title
  const resolvedMessage =
    status === 403
      ? 'Seu perfil não tem permissão para acessar este recurso.'
      : status === 404
        ? 'O registro não existe ou não está disponível para sua conta.'
        : message
  // Orientação padrão: o que aconteceu com os dados e o que fazer. Não repete quando a mensagem já orienta.
  const offline = typeof navigator !== 'undefined' && navigator.onLine === false
  const guidance =
    status === 403 || status === 404 || /tent[ea]/i.test(resolvedMessage)
      ? null
      : offline
        ? 'Parece que você está sem internet. Confira a conexão e tente de novo.'
        : 'Nada foi perdido. Confira a internet e tente de novo; se continuar, avise quem cuida do Verbum.'
  return (
    <div className="flex min-h-96 items-center justify-center">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-500/15">
          <AlertCircle className="size-8 text-red-700 dark:text-red-300" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-foreground">{resolvedTitle}</h2>
        <p className="mb-2 text-base text-muted-foreground">{resolvedMessage}</p>
        {guidance && <p className="mb-6 text-base text-muted-foreground">{guidance}</p>}
        {!guidance && <div className="mb-4" />}
        {retry && status !== 403 && status !== 404 && (
          <Button onClick={retry} variant="outline">
            Tentar novamente
          </Button>
        )}
      </div>
    </div>
  )
}

ErrorState.displayName = 'ErrorState'
